import React, { useState } from 'react';
import { evenements } from '../data/zooData';
import EventCard from '../components/EventCard';

const EvenementsPage: React.FC = () => {
  const [filter, setFilter] = useState<string>('tous');

  // Filtrer les événements par période
  const getFilteredEvents = () => {
    const now = new Date();
    
    switch(filter) {
      case 'semaine':
        const nextWeek = new Date();
        nextWeek.setDate(now.getDate() + 7);
        return evenements.filter(ev => new Date(ev.date) <= nextWeek && new Date(ev.date) >= now);
      
      case 'mois':
        const nextMonth = new Date();
        nextMonth.setMonth(now.getMonth() + 1);
        return evenements.filter(ev => new Date(ev.date) <= nextMonth && new Date(ev.date) >= now);
      
      default:
        return evenements;
    }
  };

  const filteredEvents = getFilteredEvents();

  return (
    <div className="min-h-screen pb-16">
      {/* Hero section */}
      <div 
        className="h-80 relative flex items-center justify-center"
        style={{ 
          backgroundImage: `url(https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=1920&auto=format&fit=crop)`,
          backgroundPosition: 'center',
          backgroundSize: 'cover'
        }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 text-center px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Événements & Animations
          </h1>
          <p className="text-xl text-white max-w-3xl mx-auto">
            Découvrez toutes nos activités et événements spéciaux pour enrichir votre visite
          </p>
        </div>
      </div>

      {/* Filtres par période */}
      <div className="bg-green-800 py-6">
        <div className="container mx-auto px-4">
          <div className="flex justify-center gap-2">
            <button 
              className={`px-5 py-2 rounded-full font-medium transition-colors ${filter === 'tous' ? 'bg-yellow-500 text-white' : 'bg-white text-green-800 hover:bg-green-100'}`}
              onClick={() => setFilter('tous')}
            >
              Tous
            </button>
            <button 
              className={`px-5 py-2 rounded-full font-medium transition-colors ${filter === 'semaine' ? 'bg-yellow-500 text-white' : 'bg-white text-green-800 hover:bg-green-100'}`}
              onClick={() => setFilter('semaine')}
            >
              Cette semaine
            </button>
            <button 
              className={`px-5 py-2 rounded-full font-medium transition-colors ${filter === 'mois' ? 'bg-yellow-500 text-white' : 'bg-white text-green-800 hover:bg-green-100'}`}
              onClick={() => setFilter('mois')}
            >
              Ce mois-ci
            </button>
          </div>
        </div>
      </div>

      {/* Liste des événements */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredEvents.map((event, index) => (
            <div 
              key={event.id}
              className="transform transition-all duration-500"
              style={{
                opacity: 0,
                animation: `fadeIn 0.5s ease-out ${index * 0.1}s forwards`
              }}
            >
              <EventCard event={event} />
            </div>
          ))}
        </div>

        {filteredEvents.length === 0 && (
          <div className="py-16 text-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-gray-400 mx-auto mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <h2 className="text-2xl font-semibold text-gray-600">Aucun événement à cette période</h2>
            <p className="text-gray-500 mt-2">Consultez notre calendrier complet pour voir tous nos événements</p>
            <button 
              className="mt-4 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md transition-colors"
              onClick={() => setFilter('tous')}
            >
              Voir tous les événements
            </button>
          </div>
        )}
      </div>

      {/* Section newsletter */}
      <div className="container mx-auto px-4 py-12">
        <div className="bg-green-50 rounded-xl p-8 md:p-12 shadow-lg max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8 items-center">
            <div className="md:col-span-3">
              <h2 className="text-2xl md:text-3xl font-bold text-green-900 mb-4">
                Ne manquez aucun événement !
              </h2>
              <p className="text-gray-600 mb-6">
                Inscrivez-vous à notre newsletter pour être informé en priorité des nouveaux événements et activités du zoo.
              </p>
            </div>
            <div className="md:col-span-2">
              <form className="space-y-4">
                <input 
                  type="email" 
                  placeholder="Votre adresse email" 
                  className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-600"
                  required
                />
                <button 
                  type="submit" 
                  className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-4 rounded-md transition-colors"
                >
                  S'inscrire à la newsletter
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      
      {/* Animation keyframes */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </div>
  );
};

export default EvenementsPage;
